import useAuthActiveSubscriptionTiers from '@apps/www/src/www/hooks/useAuthActiveSubscriptionTiers';
import SubscriptionTier from '@pkgs/shared/enums/SubscriptionTier';
import subscriptionTiersHasSubscriptionTierPrivileges from '@pkgs/shared/helpers/subscriptionTiersHasSubscriptionTierPrivileges';

export default function useAuthHasProPrivileges() {
	const tiers = useAuthActiveSubscriptionTiers();

	return subscriptionTiersHasSubscriptionTierPrivileges(tiers, SubscriptionTier.PRO);
}
